import Cookies from 'js-cookie'
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { cn } from '@/lib/utils'
import { SearchProvider } from '@/context/search-context'
import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/app-sidebar'
import { Footer } from '@/components/layout/footer'
import SkipToMain from '@/components/skip-to-main'
import { useAuthStore } from '@/stores/authStore'
import { allowedRolesMap } from './role-map'
import { useRouter } from '@tanstack/react-router'
import { InitialPasswordChangeDialog } from '@/components/layout/initial-password-change-dialog'
import { OnboardingTourDialog } from '@/components/layout/onboarding-tour-dialog'

function RouteComponent() {
  const defaultOpen = Cookies.get('sidebar:state') !== 'false'
  const auth = useAuthStore((s) => s.auth)
  const router = useRouter()
  const currentPath = router.state.location.pathname

  const normalizedPath = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath

  // Find the most specific matching route prefix
  const matchingKey = Object.keys(allowedRolesMap)
    .sort((a, b) => b.length - a.length) // En uzun yolu önce kontrol et (daha spesifik olanlar ezsin)
    .find((key) => normalizedPath === key || normalizedPath.startsWith(key + '/'))

  const allowedRoles = matchingKey ? allowedRolesMap[matchingKey] : undefined

  // Yetki kontrolü
  const userRole = auth.user?.role
  const yetkiliMi = !allowedRoles || (userRole && allowedRoles.includes(userRole))

  if (!yetkiliMi) {
    return (
      <div className='flex h-svh w-full items-center justify-center p-4 text-center'>
        <h1 className='text-xl font-semibold'>Bu sayfaya erişim yetkiniz yok.</h1>
      </div>
    )
  }

  return (
    <SearchProvider>
      <SidebarProvider defaultOpen={defaultOpen}>
        <SkipToMain />
        <AppSidebar />
        <InitialPasswordChangeDialog />
        <OnboardingTourDialog />
        <div
          id="content"
          className={cn(
            'ml-auto w-full max-w-full',
            'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
            'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
            'transition-[width] duration-200 ease-linear',
            'flex h-svh flex-col overflow-y-auto',
            'group-data-[scroll-locked=1]/body:h-full',
            'group-data-[scroll-locked=1]/body:has-[main.fixed-main]:h-svh'
          )}
        >
          <div className="flex-1">
            <Outlet />
          </div>
          <Footer />
        </div>
      </SidebarProvider>
    </SearchProvider>
  )
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: () => {
    const { accessToken, user } = useAuthStore.getState().auth
    if (!accessToken || !user) {
      throw redirect({
        to: '/giris-yap',
      })
    }
  },
  component: RouteComponent,
})
